import React, { useContext } from "react";
import { Flex } from "antd";
import UnsignedLayout from "./UnsignedLayout";
import SignedLayout from "./SignedLayout";
import { AuthContext } from "../features/auth/AuthProvider";

export default function RootLayout() {
  const { isLoggedIn } = useContext(AuthContext);
  return (
    <Flex gap="middle" wrap="wrap" style={{height:"100vh"}}>
      { isLoggedIn ? <SignedLayout /> : <UnsignedLayout /> }
    </Flex>
  );
}


